import { DocumentType } from './DocumentType';

export const DocStatus = {
  OPENED: 'O',
  CLOSED: 'C',
  CANCELED: 'S',
  CANCELLATION: 'R',
  DELETED: 'D',
  PLANNED: 'P',
};

export const DocStatusList = [
  { label: 'Nyitott', invoiceLabel: 'Kiállított', value: DocStatus.OPENED },
  { label: 'Zárt', value: DocStatus.CLOSED },
  { label: 'Stornózott', value: DocStatus.CANCELED },
  { label: 'Stornó', value: DocStatus.CANCELLATION },
  { label: 'Törölt', value: DocStatus.DELETED },
  { label: 'Tervezett', value: DocStatus.PLANNED },
];

export const getDocStatusList = (invoice = false) =>
  DocStatusList.map((status) => ({
    ...status,
    label: invoice && status.invoiceLabel ? status.invoiceLabel : status.label,
  }));

export const getDocStatusLabel = (value, invoice = false) =>
  getDocStatusList(invoice).find((status) => status.value === value)?.label;

export const StatusColors = {
  [DocStatus.OPENED]: 'green',
  [DocStatus.CLOSED]: 'grey',
  [DocStatus.CANCELED]: 'red',
  [DocStatus.CANCELLATION]: 'red',
};

export const DocLineStatus = {
  OPENED: 'O',
  CLOSED: 'C',
};

export const Operation = {
  STORNO: 'STORNO',
  CLOSE: 'CLOSE',
  INVOICE_MODIFICATION_ALL: 'INVOICE_MODIFICATION_ALL',
};

export const InvoiceModificationScope = {
  HEAD: 'HEAD',
  LINE: 'LINE',
  ALL: 'ALL',
};

export const OperationList = (selectedValues, currentDocTypeId = selectedValues.docTypeId, isInvoice = false) => [
  ...([DocumentType.ARInvoiceManual, DocumentType.ARInvoice, DocumentType.ARInvoiceModification].includes(Number(currentDocTypeId))
    ? [
        {
          label: 'Módosító számla',
          value: Operation.INVOICE_MODIFICATION_ALL,
          disabled: selectedValues.docStatus !== DocStatus.OPENED || Boolean(selectedValues.hasModification),
        },
      ]
    : []),
  {
    label: 'Stornózás',
    value: Operation.STORNO,
    disabled:
      Number(selectedValues.docTypeId) === DocumentType.ARInvoiceModification ||
      Boolean(selectedValues.hasModification) ||
      selectedValues.docStatus !== DocStatus.OPENED ||
      selectedValues.docLine?.some(
        (line) => line.lineStatus !== DocLineStatus.OPENED || Number(line.cplQty ?? 0) !== 0
      ),
  },
  ...(!isInvoice
    ? [{ label: 'Bezárás', value: Operation.CLOSE, disabled: selectedValues.docStatus !== DocStatus.OPENED }]
    : []),
];

export const DocLineStatusList = [
  { label: 'Nyitott', value: DocLineStatus.OPENED },
  { label: 'Zárt', value: DocLineStatus.CLOSED },
];

export const docRelation = {
  [DocumentType.CustomerOrder]: [
    DocumentType.Delivery,
    DocumentType.CompletionCertificate,
    DocumentType.DownPaymentRequest,
    DocumentType.PurchaseOrder,
    DocumentType.PurchaseOrderVariant,
  ],
  [DocumentType.SalesQuotation]: [DocumentType.CustomerOrder],
  [DocumentType.Delivery]: [DocumentType.ARInvoice, DocumentType.Return],
  [DocumentType.DownPaymentRequest]: [DocumentType.DownPayment],
  [DocumentType.ARInvoiceManual]: [DocumentType.ARInvoiceModification],
  [DocumentType.ARInvoice]: [DocumentType.ARInvoiceModification],
  [DocumentType.ARInvoiceModification]: [DocumentType.ARInvoiceModification],
  [DocumentType.APDownPaymentRequest]: [DocumentType.APDownPayment],
  [DocumentType.GoodsIssue]: [DocumentType.ReturnFromIssue],
  [DocumentType.ProjectIssue]: [DocumentType.ProjectReturn],
  [DocumentType.CooperationIssue]: [DocumentType.CooperationReturn],
  [DocumentType.EmployeeIssue]: [DocumentType.EmployeeReturn],
  [DocumentType.APInvoice]: [DocumentType.PurchaseDelivery],
  [DocumentType.PurchaseQuotation]: [DocumentType.PurchaseOrder, DocumentType.PurchaseOrderVariant],
  [DocumentType.CooperationReturn]: [DocumentType.APInvoice],
  [DocumentType.PurchaseDelivery]: [DocumentType.APInvoice, DocumentType.GoodsReturn],
  [DocumentType.PurchaseOrder]: [DocumentType.PurchaseDelivery, DocumentType.APDownPaymentRequest],
  [DocumentType.PurchaseOrderVariant]: [DocumentType.PurchaseDelivery, DocumentType.APDownPaymentRequest],
};

export const docSourceRelation = {
  [DocumentType.Delivery]: [DocumentType.CustomerOrder],
  [DocumentType.CompletionCertificate]: [DocumentType.CustomerOrder],
  [DocumentType.ARInvoiceManual]: [DocumentType.Delivery],
  [DocumentType.ARInvoice]: [DocumentType.Delivery],
  [DocumentType.ARInvoiceModification]: [DocumentType.ARInvoiceManual, DocumentType.ARInvoice, DocumentType.ARInvoiceModification],
  [DocumentType.PurchaseDelivery]: [DocumentType.PurchaseOrder, DocumentType.PurchaseOrderVariant],
  [DocumentType.APInvoice]: [DocumentType.PurchaseDelivery, DocumentType.CooperationReturn],
  [DocumentType.CustomerOrder]: [DocumentType.SalesQuotation],
  [DocumentType.ReturnFromIssue]: [DocumentType.GoodsIssue],
  [DocumentType.ProjectReturn]: [DocumentType.ProjectIssue],
  [DocumentType.CooperationReturn]: [DocumentType.CooperationIssue],
  [DocumentType.EmployeeReturn]: [DocumentType.EmployeeIssue],
  [DocumentType.PurchaseOrder]: [DocumentType.PurchaseQuotation],
  [DocumentType.APDownPaymentRequest]: [DocumentType.PurchaseOrder, DocumentType.PurchaseOrderVariant],
  [DocumentType.APDownPayment]: [DocumentType.APDownPaymentRequest],
  [DocumentType.Return]: [DocumentType.Delivery],
  [DocumentType.GoodsReturn]: [DocumentType.PurchaseDelivery],
};
